import { INavData } from '@coreui/angular';

export const defaultNavItems: INavData[] = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'pi pi-home'
	},
	{
		title: true,
		name: 'Accesos Rapidos'
	},
	{
		name: 'Reels',
		url: '/admin/svs/reels',
		icon: 'pi pi-video'
	},
	{
		name: 'Layouts',
		url: '/admin/svs/layouts',
		icon: 'pi pi-images'
	},
	{
		title: true,
		name: 'General'
	},
	{
		name: 'Configuración',
		url: '/admin/admin',
		icon: 'pi pi-cog',
		children: [
			{
				name: 'Usuario',
				url: '/admin/svs/usuarios',
				icon: 'pi pi-user'
			},
			{
				name: 'Clientes',
				url: '/client/config/clientes',
				icon: 'pi pi-briefcase'
			},
			{
				name: 'Roles',
				url: '/client/config/roles',
				icon: 'pi pi-id-card'
			},
			{
				name: 'Permisos',
				url: '/client/config/permisos',
				icon: 'pi pi-lock'
			},
			{
				name: 'Diseñador de Reels (BETA)',
				url: '/client/config/design-reels',
				icon: 'pi pi-lock'
			},
			// {
			// 	name: 'Mi Perfil',
			// 	url: '/client/config/perfil',
			// 	icon: 'pi pi-pencil'
			// },
		]
	},
	{
		name: 'Unidades Moviles',
		url: '/admin/admin',
		icon: 'pi pi-car',
		children: [
			{
				name: 'Grupos de Unidades',
				url: '/admin/svs/groups',
				icon: 'pi pi-sitemap'
			},
			{
				name: 'Categorias de Reels',
				url: '/admin/svs/reel-categories',
				icon: 'pi pi-tags'
			}
		]
	},
	{
		name: 'Media',
		url: '/admin/admin',
		icon: 'pi pi-folder',
		children: [
			{
				name: 'Layouts',
				url: '/admin/svs/layouts',
				icon: 'pi pi-images'
			},
			// {
			// 	name: 'Estadísticas',
			// 	url: '/admin/svs/media-kpi',
			// 	icon: 'pi pi-images'
			// },
			{
				name: 'Categorias',
				url: '/client/config/categorias',
				icon: 'pi pi-tags'
			},
		]
	},
	{
		name: 'Router',
		url: '/admin/admin',
		icon: 'pi pi-globe',
		children: [
			{
				name: 'boxes',
				url: '/admin/admin/boxes',
				icon: 'pi pi-desktop'
			}
		]
	},
];

export const navGroup = {
	name: 'Grupos de Unidades',
	url: '/admin/svs/groups',
	icon: 'pi pi-sitemap'
};

export const navReels = {
	name: 'Reels',
	url: '/admin/svs/reels',
	icon: 'pi pi-video'
};

export const navUnits = {
	name: 'Unidades',
	url: '/admin/svs/units',
	icon: 'pi pi-mobile'
};

export const navMedia = {
	name: 'Media',
	url: '/admin/svs/media',
	icon: 'pi pi-images'
};

export const navItemsUserRole: INavData[] = [
	// {
	// 	name: 'Dashboard',
	// 	url: '/dashboard',
	// 	icon: 'pi pi-home',
	// },
	navMedia,
	navReels,
	navUnits,
	navGroup,

];
